import { render, staticRenderFns } from "./ReferenceSelect.vue?vue&type=template&id=7c0456fa&"
import script from "./ReferenceSelect.vue?vue&type=script&lang=js&"
export * from "./ReferenceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports